(function () {
  function clip(s, max) {
    max = max == null ? 100 : max;
    if (s == null || s === '') return '';
    s = String(s);
    return s.length <= max ? s : s.substring(0, max);
  }

  function readJourneyContext(el) {
    var extra = {
      click_source_path: clip(window.location.pathname, 200),
    };

    var main = document.getElementById('MainContent');
    if (main && main.dataset && main.dataset.template) {
      extra.click_source_template = clip(main.dataset.template, 80);
    }

    var dest = el.getAttribute('data-ga-destination');
    if (!dest && el.tagName === 'A') {
      dest = el.getAttribute('href') || '';
    }
    if (dest) {
      extra.click_destination = clip(dest, 300);
    }

    var ctaType = el.getAttribute('data-ga-cta-type');
    if (ctaType) {
      extra.click_cta_type = clip(ctaType, 50);
    }

    var collectionHandle = el.getAttribute('data-ga-collection');
    if (collectionHandle) {
      extra.click_collection = clip(collectionHandle, 100);
    }

    return extra;
  }

  function pushOleumEventoclick(name, extra) {
    if (!name) return;

    var payload = { event: 'eventoclick', eventoclick: name };
    if (extra && typeof extra === 'object') {
      Object.keys(extra).forEach(function (key) {
        payload[key] = extra[key];
      });
    }

    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push(payload);
    }

    if (typeof window.gtag === 'function') {
      var gtagPayload = { event_label: clip(name, 100) };
      if (extra && typeof extra === 'object') {
        Object.keys(extra).forEach(function (key) {
          var val = extra[key];
          gtagPayload[key] = typeof val === 'string' ? clip(val, 100) : val;
        });
      }
      window.gtag('event', 'eventoclick', gtagPayload);
    }
  }

  window.pushOleumEventoclick = pushOleumEventoclick;

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-eventoclick]') : null;
    if (!el) return;
    var name = el.getAttribute('data-eventoclick');
    if (!name) return;
    pushOleumEventoclick(name, readJourneyContext(el));
  });
})();
